export interface CancelableRegulationInit {
  type: string;
  until: number;
  prepayable: boolean;
  refundableDaysLimit: number;
}

export default class CancelableRegulation {
  public readonly type: string;
  public readonly until: number;
  public readonly prepayable: boolean;
  public readonly refundableDaysLimit: number;

  constructor(init: CancelableRegulationInit) {
    this.type = init.type;
    this.until = init.until;
    this.prepayable = init.prepayable;
    this.refundableDaysLimit = init.refundableDaysLimit;
  }
}
